import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/aica.svg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoader(true);
    try {
      const res = await axios.post("https://www.careplus.gopillz.com/admin_login", {
        email,
        password,
      });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("login", true);
      navigate("/admin-dashboard");
    } catch (err) {
      alert("Invalid credentials");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200">
      <div className="bg-white p-10 shadow-2xl rounded-2xl w-full max-w-md flex flex-col items-center space-y-6">
        <img src={logo} alt="Logo" className="w-20 h-20 mb-4" />
        <h2 className="text-3xl font-bold text-indigo-800">Admin Login</h2>

        <input
          className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-300 text-sm"
          placeholder="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-300 text-sm"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white p-3 rounded-xl font-semibold transition-all duration-200 disabled:opacity-50"
          onClick={handleLogin}
          disabled={loader}
        >
          {loader ? (
            <div className="flex items-center justify-center">
              <svg className="animate-spin h-5 w-5 text-white mr-2" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                />
              </svg>
              Logging in...
            </div>
          ) : (
            "Login"
          )}
        </button>
      </div>
    </div>
  );
};

export default Login;
